import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { PiBuildingOfficeBold, PiStudent } from "react-icons/pi";
import { formatMoney, formatMoneyShorten } from "../Helpers";
import { FaChalkboardTeacher } from "react-icons/fa";
import { SiGoogleclassroom } from "react-icons/si";
import { IoIosPeople } from "react-icons/io";
import { getInlineLoader } from "../Helpers";
import HomeBanner1 from "../ones/HomeBanner1";

import Footer from "../ones/Footer";
import banner1 from '../assets/banners/banner1.jpg';
import banner2 from '../assets/banners/banner2.jpg';
import banner3 from '../assets/banners/banner3.png';
import pr1 from '../assets/med/pr1.jpg';
import pr2 from '../assets/med/pr2.png';
import pr3 from '../assets/med/pr3.jpg';
import pr4 from '../assets/med/pr4.png';
import pr5 from '../assets/med/pr5.png';
import pr6 from '../assets/med/pr6.png';
import pr7 from '../assets/med/pr7.png';
import pr8 from '../assets/med/pr8.png';

import { IoMdCheckmarkCircleOutline } from "react-icons/io";
import { FaArrowCircleRight } from "react-icons/fa";
import { MdArrowCircleLeft, MdArrowCircleRight } from "react-icons/md";

export default function View(props) {

	const appContext = useContext(AppContext);

	/* Place states here */
	const [ ready, setReady ] = useState(false);
	const [ bgIndex, setBgIndex ] = useState(0);
	const banners = [banner1, banner2, banner3];

	async function init() {
		//run initializations here
		setReady(false);
		//..
		
		setReady(true);
	}

	useEffect(() => {
		init();
	}, [ ])

	// Background transition effect
	useEffect(() => {
		if (!ready) return;

		const interval = setInterval(() => {
			setBgIndex(prev => (prev + 1) % banners.length);
		}, 2500); // change every 5 seconds

		return () => clearInterval(interval);
	}, [ready]);

	if(ready) {
		return (
			<>
				<div className="MainBodySection">
					<div
						style={{
							width: "100%",
							height: "auto",
							position: "relative",
							overflow: "hidden"
						}}
					>
						{banners.map((banner, i) => (
							<div
								key={i}
								style={{
									backgroundImage: `url(${banner})`,
									backgroundAttachment: "fixed",
									backgroundSize: "cover",
									backgroundPosition: "center",
									width: "100%",
									height: "100%",
									position: "absolute",
									top: 0,
									left: 0,
									transition: "opacity 1.5s ease-in-out",
									opacity: i === bgIndex ? 1 : 0,
								}}
							/>
						))}
	
						{/* gradient overlay */}
						<div
							style={{
								width: "100%",
								height: "100%",
								background: "linear-gradient(to right, rgba(0,0,0,0.9) 0%, rgba(0,0,0,0.4) 80%, rgba(0,0,0,0) 100%)",
								position: "relative",
								zIndex: 1
							}}
						>
							<div className="container">
								<div className="row">
									<div className="col-md-6">
										<h1
											className="font-bold text-light"
											style={{
												fontSize: "32px",
												paddingTop: "40px",
												paddingBottom: "40px",
												textTransform: "uppercase",
											}}
										>
											MEDICAL GAS SYSTEMS
										</h1>
	
										
	
									</div>
	
									
	
								</div>
							</div>
						</div>
	
					</div>
				</div>
				
				<div 
					className="MainBodySection"
					style={{
						paddingBottom: "50px",
						paddingTop: "50px"
					}}
				>
					<div className="container">
						<div className="row">

							<div className="col-md-12 mt-3 mb-3">
								<img
									src={banner1}
									style={{
										width: "100%"
									}}
								/>
								<h6
									style={{
										fontSize: "24px",
										marginTop: "20px",
										marginBottom: "20px",
									}}
								>
									We supply various medical gas systems and related products including:-
								</h6>

								
							</div>

							<div className="col-md-4 mt-3 mb-3">
								<div 
									className="card"
									onClick={() => {
										appContext.navTo({
											item: 'services',
											subItem: 'oxygen_generator'
										})
									}}
									style={{
										cursor: "pointer",
									}}
								>
									<div className="card-body">

										<img
											style={{
												width: "100%",
												height: "200px",
												objectFit: "cover",
												objectPosition: "center"
											}}
											src={pr1}
										/>

										<h6
											className="font-bold text-center mt-4 text-primary"
											
											style={{
												fontSize: "18px",
												height: "60px"
											}}
										>
											Oxygen Generator
											<br/>
											<MdArrowCircleRight size={24}/>
										</h6>
										
									</div>
								</div>
							</div>

							
							<div className="col-md-4 mt-3 mb-3">
								<div 
									className="card"
									onClick={() => {
										appContext.navTo({
											item: 'services',
											subItem: 'gas_manifold'
										})
									}}
									style={{
										cursor: "pointer",
									}}
								>
									<div className="card-body">

										<img
											style={{
												width: "100%",
												height: "200px",
												objectFit: "cover",
												objectPosition: "center"
											}}
											src={pr2}
										/>

										<h6
											className="font-bold text-center mt-4 text-primary"
											
											style={{
												fontSize: "18px",
												height: "60px"
											}}
										>
											Medical Gas Manifold
											<br/>
											<MdArrowCircleRight size={24}/>
										</h6>
										
									</div>
								</div>
							</div>

							<div className="col-md-4 mt-3 mb-3">
								<div 
									className="card"
									onClick={() => {
										appContext.navTo({
											item: 'services',
											subItem: 'bed_head_unit'
										})
									}}
									style={{
										cursor: "pointer",
									}}
								>
									<div className="card-body">

										<img
											style={{
												width: "100%",
												height: "200px",
												objectFit: "cover",
												objectPosition: "center"
											}}
											src={pr3}
										/>

										<h6
											className="font-bold text-center mt-4 text-primary"
											
											style={{
												fontSize: "18px",
												height: "60px"
											}}
										>
											Bed Head Unit
											<br/>
											<MdArrowCircleRight size={24}/>
										</h6>
										
									</div>
								</div>
							</div>

							<div className="col-md-4 mt-3 mb-3">
								<div 
									className="card"
									onClick={() => {
										appContext.navTo({
											item: 'services',
											subItem: 'gas_outlet'
										})
									}}
									style={{
										cursor: "pointer",
									}}
								>
									<div className="card-body">

										<img
											style={{
												width: "100%",
												height: "200px",
												objectFit: "cover",
												objectPosition: "center"
											}}
											src={pr4}
										/>

										<h6
											className="font-bold text-center mt-4 text-primary"
											
											style={{
												fontSize: "18px",
												height: "60px"
											}}
										>
											Medical Gas Outlet
											<br/>
											<MdArrowCircleRight size={24}/>
										</h6>
										
									</div>
								</div>
							</div>

							<div className="col-md-4 mt-3 mb-3">
								<div 
									className="card"
									onClick={() => {
										appContext.navTo({
											item: 'services',
											subItem: 'gas_alarm'
										})
									}}
									style={{
										cursor: "pointer",
									}}
								>
									<div className="card-body">

										<img
											style={{
												width: "100%",
												height: "200px",
												objectFit: "cover",
												objectPosition: "center"
											}}
											src={pr5}
										/>

										<h6
											className="font-bold text-center mt-4 text-primary"
											
											style={{
												fontSize: "18px",
												height: "60px"
											}}
										>
											Medical Gas Alarm
											<br/>
											<MdArrowCircleRight size={24}/>
										</h6>
										
									</div>
								</div>
							</div>

							<div className="col-md-4 mt-3 mb-3">
								<div 
									className="card"
									onClick={() => {
										appContext.navTo({
											item: 'services',
											subItem: 'vacuum_system'
										})
									}}
									style={{
										cursor: "pointer",
									}}
								>
									<div className="card-body">

										<img
											style={{
												width: "100%",
												height: "200px",
												objectFit: "cover",
												objectPosition: "center"
											}}
											src={pr6}
										/>

										<h6
											className="font-bold text-center mt-4 text-primary"
											
											style={{
												fontSize: "18px",
												height: "60px"
											}}
										>
											Medical Vacuum System
											<br/>
											<MdArrowCircleRight size={24}/>
										</h6>
										
									</div>
								</div>
							</div>

							<div className="col-md-4 mt-3 mb-3">
								<div 
									className="card"
									onClick={() => {
										appContext.navTo({
											item: 'services',
											subItem: 'oxygen_therapy'
										})
									}}
									style={{
										cursor: "pointer",
									}}
								>
									<div className="card-body">

										<img
											style={{
												width: "100%",
												height: "200px",
												objectFit: "cover",
												objectPosition: "center"
											}}
											src={pr7}
										/>

										<h6
											className="font-bold text-center mt-4 text-primary"
											
											style={{
												fontSize: "18px",
												height: "60px"
											}}
										>
											Oxygen Therapy
											<br/>
											<MdArrowCircleRight size={24}/>
										</h6>
										
									</div>
								</div>
							</div>

							<div className="col-md-4 mt-3 mb-3">
								<div 
									className="card"
									onClick={() => {
										appContext.navTo({
											item: 'services',
											subItem: 'operating_theatre'
										})
									}}
									style={{
										cursor: "pointer",
									}}
								>
									<div className="card-body">

										<img
											style={{
												width: "100%",
												height: "200px",
												objectFit: "cover",
												objectPosition: "center"
											}}
											src={pr8}
										/>

										<h6
											className="font-bold text-center mt-4 text-primary"
											
											style={{
												fontSize: "18px",
												height: "60px"
											}}
										>
											Modular Operating Theatre
											<br/>
											<MdArrowCircleRight size={24}/>
										</h6>
										
									</div>
								</div>
							</div>
	
						</div>
					</div>
				</div>

				<Footer/>
			</>
		)
	} else {
		return (
			<div 
				className="container mSupportLoading"
			>
				{getInlineLoader()}
			</div>
		);
	}

	
}
